import type { FluxErrorEntityErrorCodes } from '../types.js';

export const UserErrorCodes = {
  UserForbiddenProvider: {
    code: 'user/forbidden-provider',
    message: 'O seu método de autenticação não é suportado por esta ação.',
    explanation: 'O provedor de autenticação que você está usando não é suportado para este usuário.',
    localizations: {},
  },
  UserInvalidIdentifiable: {
    code: 'user/invalid-identifiable',
    message: 'O identificador fornecido para o usuário é inválido.',
    explanation: 'O identificador fornecido para o usuário é inválido. O identificador deve conter um e-mail ou ID válido, caso os dois sejam fornecidos, o ID terá prioridade.',
    localizations: {},
  },
  UserNotFound: {
    code: 'user/not-found',
    message: 'Usuário não encontrado.',
    explanation: 'O usuário que você está tentando acessar não foi encontrado. Verifique se o e-mail ou ID está correto ou se o usuário ainda faz parte da conta. Você também pode tentar convidar o usuário novamente',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'user'>;

export const UserInviteErrorCodes = {
  UserInviteAboveRoleHierarchy: {
    code: 'user-invite/above-role-hierarchy',
    message: 'Você não tem permissão para convidar usuários para este cargo.',
    explanation: 'Você não pode convidar um usuário para um papel (role) que está acima de você na hierarquia. Apenas usuários com cargos superiores na hierarquia podem fazer convites para este nível de permissão.',
    localizations: {},
  },
  UserInviteAlreadyInteracted: {
    code: 'user-invite/already-interacted',
    message: 'O convite já foi aceito ou recusado.',
    explanation: 'O convite de usuário que você está tentando acessar já foi aceito ou recusado.',
    localizations: {},
  },
  UserInviteInvalidToken: {
    code: 'user-invite/invalid-token',
    message: 'O token do convite é inválido ou expirou.',
    explanation: 'O token do convite de usuário é inválido ou expirou.',
    localizations: {},
  },
  UserInviteNotFound: {
    code: 'user-invite/not-found',
    message: 'Convite não encontrado.',
    explanation: 'O convite de usuário que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
  UserInviteRoleNotFound: {
    code: 'user-invite/role-not-found',
    message: 'O cargo especificado no convite não foi encontrado.',
    explanation: 'O papel (role) especificado no convite de usuário não foi encontrado.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'user-invite'>;

export const UserLicenseErrorCodes = {
  UserLicenseAlreadyExists: {
    code: 'user-license/already-exists',
    message: 'Este usuário já possui uma licença ativa.',
    explanation: 'O usuário já possui uma licença ativa. Cada usuário só pode ter uma licença ativa por vez.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Licenças',
        path: '/wiki/docs/licencas/intro',
      },
      {
        name: 'Alterando licenças',
        path: '/wiki/docs/licencas/alterando-licencas',
      },
    ],
  },
  UserLicenseGlobalOwnerForbidden: {
    code: 'user-license/global-owner-forbidden',
    message: 'Não é possível alterar a licença do proprietário da conta.',
    explanation: 'Você não pode alterar a licença do proprietário da conta global.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Licenças',
        path: '/wiki/docs/licencas/intro',
      },
      {
        name: 'Alterando licenças',
        path: '/wiki/docs/licencas/alterando-licencas',
      },
    ],
  },
  UserLicenseLimitReached: {
    code: 'user-license/limit-reached',
    message: 'O número máximo de licenças ativas para esta conta foi atingido. Remova uma licença existente para adicionar uma nova.',
    explanation: 'O número máximo de licenças ativas para esta conta foi atingido. Para aumentar o número de licenças, remova uma licença existente ou entre em contato com o suporte.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Licenças',
        path: '/wiki/docs/licencas/intro',
      },
    ],
  },
  UserLicenseNotAssigned: {
    code: 'user-license/not-assigned',
    message: 'Este usuário não possui uma licença atribuída.',
    explanation: 'O usuário não possui uma licença atribuída. Atribua uma licença para que ele possa acessar todos os recursos da plataforma.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Licenças',
        path: '/wiki/docs/licencas/intro',
      },
      {
        name: 'Alterando licenças',
        path: '/wiki/docs/licencas/alterando-licencas',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'user-license'>;
